// extracted by mini-css-extract-plugin
module.exports = {"FooterBaseLinks":"styles_FooterBaseLinks__9V1Jy"};